<template>
  <div class="job-referrals-container">
    <template v-if="layout === 'block'">
      <div class="loading-panel" v-if="loading">
        <loading-spinner/>
      </div>
      <template v-else>
        <b-row class="job-referrals-block" v-if="total">
          <b-col class="filter-entry" cols="12" v-for="{ entry } in results.edges" :key="entry.id">
            <job-referral-list-item :referral="entry" @finished="() => $emit('finished', { referralID: entry.id })"/>
          </b-col>
        </b-row>
      </template>
    </template>
    <template v-if="layout === 'page'">
      <b-row class="job-referrals-page">
        <b-col class="filter-entry" cols="12" md="6" v-for="{ entry } in results.edges" :key="entry.id">
          <job-referral-list-item :referral="entry" @finished="() => $emit('finished', { referralID: entry.id })"/>
        </b-col>
      </b-row>
      <div v-if="page && totalPages" class="filter-pagination">
        <p>Page {{ page }} of {{ totalPages }}</p>
        <b-pagination :value="page" @input="v => $emit('pageUpdated', v)" :per-page="limit" :total-rows="total"/>
      </div>
    </template>
  </div>
</template>

<script>
import JobReferralListItem, { JobReferralListItemFragment } from '@/components/job-referrals/list-item';
import LoadingSpinner from '@src/components/misc/LoadingSpinner';

export { JobReferralListItemFragment };

export default {
  name: 'JobReferralsContainer',
  props: {
    layout: {
      type: String,
      default: () => 'block',
      validate: layout => [ 'block', 'page' ].includes(layout),
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    // where: {
    //   type: Object,
    //   default: () => ({}),
    // },
    // order: {
    //   type: String,
    //   default: () => null,
    // },
    // orderOptions: {
    //   type: Object,
    //   default: () => null,
    // },
    results: {
      type: Object,
      default: () => ({
        edges: [],
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0,
      }),
      validate: ({ edges, page, limit, total, totalPages }) =>
        Array.isArray(edges) &&
        Number.isInteger(page) && Number.isInteger(limit) &&
        Number.isInteger(total) && Number.isInteger(totalPages),
    },
  },
  components: {
    JobReferralListItem,
    LoadingSpinner,
  },
  computed: {
    page() {
      const { page } = this.results;
      return page || 1;
    },
    limit() {
      const { limit } = this.results;
      return limit || 10;
    },
    total() {
      const { total } = this.results;
      return total || 0;
    },
    totalPages() {
      const { totalPages } = this.results;
      return totalPages || 1;
    },
  },
};
</script>

<style lang="scss">
.job-referrals-container {

  .job-referrals-block {
    .filter-entry {
      margin-bottom: 20px;
    }
  }

  .job-referrals-page {
    .filter-entry {
      margin-bottom: 30px;
    }
  }

  .filter-pagination {
    margin: 50px 0 20px 0;

    p {
      text-align: center;
    }

    ul {
      justify-content: center;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/job-referrals/container.vue